/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/common/footer.js":
/*!*********************************!*\
  !*** ./src/js/common/footer.js ***!
  \*********************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"default\": () => (__WEBPACK_DEFAULT_EXPORT__)\n/* harmony export */ });\n// Make the Newsletter pop-up appear if the footer email input field is focused\nvar FooterNewsletter = function FooterNewsletter() {\n  var footer_newsletter_field = document.querySelector('footer .footer__block--newsletter .button');\n  var newsletter_popup = document.querySelector('newsletter-popup');\n  if (footer_newsletter_field && newsletter_popup) {\n    footer_newsletter_field.addEventListener(\"click\", function (e) {\n      e.preventDefault();\n      newsletter_popup.setAttribute('open', '');\n    });\n\n    /**\n     * Custom error message for already subscribed users\n     */\n    var catchAlreadySubscribedError = function catchAlreadySubscribedError() {\n      var LIVE_URL = window.location.href;\n      var email_input = document.querySelector('[name=\"contact[email]\"');\n      var result = LIVE_URL.includes('form_type=customer');\n      var message_banner = newsletter_popup.querySelector('.already-subscribed');\n      var error_banner = newsletter_popup.querySelector('.banner.banner--error');\n      if (error_banner) {\n        error_banner.hidden = true;\n      }\n      if (message_banner && result && email_input && email_input.value.length != 0) {\n        message_banner.hidden = false;\n        newsletter_popup.setAttribute('open', '');\n      }\n    };\n    catchAlreadySubscribedError();\n  }\n};\n/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FooterNewsletter);\n\n//# sourceURL=webpack://lanvin-shopify-theme/./src/js/common/footer.js?");

/***/ }),

/***/ "./src/js/common/localization.js":
/*!***************************************!*\
  !*** ./src/js/common/localization.js ***!
  \***************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\nvar params = new URLSearchParams(document.location.search);\nvar country = params.get('country');\nif (country != null) {\n  var new_url = window.location.href.split('?');\n  window.history.pushState({}, document.title, new_url[0]);\n  var formData = new FormData();\n  formData.append('form_type', 'localization');\n  formData.append('utf8', '✓');\n  formData.append('_method', 'put');\n  formData.append('return_to', new_url[0]);\n  formData.append('country_code', country.toUpperCase());\n  fetch(\"/localization\", {\n    method: \"POST\",\n    body: formData\n  });\n}\n\n//# sourceURL=webpack://lanvin-shopify-theme/./src/js/common/localization.js?");

/***/ }),

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _common_footer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common/footer.js */ \"./src/js/common/footer.js\");\n/* harmony import */ var _common_localization_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./common/localization.js */ \"./src/js/common/localization.js\");\n\n\n(0,_common_footer_js__WEBPACK_IMPORTED_MODULE_0__[\"default\"])();\n\n//# sourceURL=webpack://lanvin-shopify-theme/./src/js/main.js?");

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://lanvin-shopify-theme/./src/scss/main.scss?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	__webpack_require__("./src/js/main.js");
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scss/main.scss");
/******/ 	
/******/ })()
;